import { z } from 'zod'

export const counterSchema = z.object({
  withGiftGiver: z.number(),
  withoutGiftGiver: z.number()
})

export const countersResponseSchema = z.object({
  data: counterSchema
})

export type CountersResponse = z.infer<typeof countersResponseSchema>
